/**
 * One place that decides what a user gets (ads, later premium features).
 * Today: a local "supporter" flag (URL ?supporter=1 / ?supporter=0 for testing).
 * Later: a license key or an account from the MC Planner server — only this file changes.
 */
import { isDesktop } from "./desktop.ts";

const KEY = "mcp-supporter";

/**
 * Which ad network fills the slot. "placeholder" = our own neutral card (no tracking, no consent needed).
 * Off unless a build asks for it (VITE_AD_PROVIDER=placeholder): no ads at launch for anyone (PLAN-paywall, P4).
 */
export type AdProvider = "placeholder" | "off";
export const AD_PROVIDER: AdProvider = ((import.meta.env?.VITE_AD_PROVIDER as string | undefined) === "placeholder" ? "placeholder" : "off");

function read(): boolean {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

/** Apply ?supporter=1 / ?supporter=0 from the address bar (testing hook) and remove it from the URL. */
export function applySupporterParam() {
  try {
    const u = new URL(location.href);
    const v = u.searchParams.get("supporter");
    if (v === null) return;
    setSupporter(v === "1");
    u.searchParams.delete("supporter");
    history.replaceState(null, "", u.pathname + u.search + u.hash);
  } catch { /* ignore */ }
}

export function isSupporter(): boolean {
  return read();
}

export function setSupporter(on: boolean) {
  try { if (on) localStorage.setItem(KEY, "1"); else localStorage.removeItem(KEY); } catch { /* ignore */ }
}

/** Ads only on the website, never in the desktop app, never for supporters. */
export function adsEnabled(supporter = isSupporter()): boolean {
  return AD_PROVIDER !== "off" && !isDesktop() && !supporter;
}
